import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'TopMenu' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    }
});
